import CourseProgress from './CourseProgress';
export default CourseProgress;
